import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { update } from "../../services/item_copies.service";
import { MESSAGE } from "../../config/index";
import { API_URL } from '../../config/urls';
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import route from '../../config/routes';
import $ from 'jquery';
import LoadingButton from "../fields/LoadingButton";
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';

const { UPDATE, EMPTY } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: API_URL.ADMIN_TRADING_API + route.GET_NFT_COPIES,
            item: {},
            name: "",
            amount: 0,
            item_order: 0,
            blockchain: "",
            is_active: false,
            is_locked: false,
            is_minted: false,
            is_transferring: false,
            is_released: false,
            is_meta: false,
            enable_sale: false,
            transaction_hash: "",
            btnIsDisable: false
        };

        this.onUpdate = this.onUpdate.bind(this);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    handleValueChange = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [`${name}`]: value
        });

        if (name === "amount") this.setState({ ...await validateField("decimal", name, value, "", 1, "Amount") });
    }

    componentDidMount() {
        let that = this;
        if (!this.props.id) {
            this.setState({
                isLoading: false
            });
        }
        if (this.props.id) {
            let id = this.props.id;
            this.getById(id);
        }

        $(".close-slide").click(function () {
            that.resetForm();
            that.props.closeEditModal();
        });
    }

    getById(id) {
        var $this = this;

        axios
            .get(this.state.url + "/" + id, Helping.getConfig())
            .then(response => {
                let item = response.data.payload;
                let today = new Date();
                let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()

                $this.setState({
                    name: item.item.name,
                    blockchain: item.which_bc ? item.which_bc : "",
                    amount: parseFloat(item.amount),
                    is_active: item.isActive,
                    is_locked: item.isLocked,
                    is_minted: item.isMinted,
                    is_released: item.is_released,
                    is_transferring: item.isTransferring,
                    is_meta: item.is_meta,
                    enable_sale: item.enableSale,
                    item_order: item.item_order,
                    transaction_hash: item.transactionHash,
                    minExpireAt: date,
                });
            })
            .catch(error => {
                console.log("error", error);
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        isLoading: false
                    });
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, "fetching nft copy")
                })
            });
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false;

        if (Number(state.amount.length) === 0) {
            let errorObject = setErrorFields("Amount", Helping.getMessageString(EMPTY, "Amount"));
            this.setState(errorObject);
            formHasError = true;
        }
        return formHasError;
    }

    onUpdate(e) {
        e.preventDefault();

        let self = this,
            state = this.state,
            formHasError = this.checkEmptyInputFields(),
            id = this.props.id;
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            amount: parseFloat(state.amount),
            is_active: state.is_active,
            is_locked: state.is_locked,
            isMinted: state.is_minted,
            is_released: state.is_released,
            is_transferring: state.is_transferring,
            is_meta: state.is_meta,
            enable_sale: state.enable_sale,
            item_order: state.item_order,
            transaction_hash: state.transaction_hash
        };

        axios
            .put(self.state.url + "/" + id, data, Helping.getConfig())
            .then(response => {
                this.props.update(response.data.payload);
                self.setState({
                    error_message: Helping.getMessageString(UPDATE, "NFT copy"),
                    error_type: "success",
                    btnIsDisable: false
                });
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return self.setState({
                        error_message: error.response.data.message,
                        error_type: "danger",
                        btnIsDisable: false
                    });
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "updating nft copy")
                })
            });
    }

    resetForm = () => (
        this.setState({
            name: "",
            amount: 0,
            item_order: 0,
            blockchain: "",
            is_active: false,
            is_locked: false,
            is_minted: false,
            is_transferring: false,
            is_released: false,
            is_meta: false,
            enable_sale: false,
            transaction_hash: "",
            btnIsDisable: false,
            error_name_message: "",
            error_amount_message: "",
            error_item_order_message: "",
            error_blockchain_message: "",
            error_transaction_hash_message: ""
        })
    )

    render() {
        return (
            <div class="actionModal modal fade edit-nftCopies" id="editNFTCopies" tabindex="-1" role="dialog" aria-labelledby="editNFTCopies" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Edit NFT Copies</h5>
                        </div>

                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                            />
                        }

                        <div class="modal-body">
                            <div class="form-group">
                                <label for="nftName">Name</label>
                                <input type="text" class={`form-control ${this.state.error_name_message ? 'error-input' : ''}`} value={this.state.name} id="nftName" disabled />
                                <span className="error-msg">{this.state.error_name_message}</span>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="nftBlockchain">Blockchain</label>
                                        <input type="text" class={`form-control ${this.state.error_blockchain_message ? 'error-input' : ''}`} value={this.state.blockchain} id="nftBlockchain" disabled />
                                        <span className="error-msg">{this.state.error_blockchain_message}</span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="nftAmount">Amount</label>
                                        <input type="text" name="amount" class={`form-control ${this.state.error_amount_message ? 'error-input' : ''}`} value={this.state.amount} id="nftAmount" onChange={(e) => this.handleValueChange(e)} />
                                        <span className="error-msg">{this.state.error_amount_message}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="ItemOrder">Item Order</label>
                                        <input type="text" name="item_order" class={`form-control ${this.state.error_item_order_message ? 'error-input' : ''}`} value={this.state.item_order} id="ItemOrder" onChange={(e) => this.handleValueChange(e)} />
                                        <span className="error-msg">{this.state.error_item_order_message}</span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="TranHash">Transaction Hash</label>
                                        <input type="text" name="transaction_hash" class={`form-control ${this.state.error_transaction_hash_message ? 'error-input' : ''}`} value={this.state.transaction_hash} id="TranHash" onChange={(e) => this.handleValueChange(e)} />
                                        <span className="error-msg">{this.state.error_transaction_hash_message}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="userAccess">
                                <div class="row switch">
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Active:</span>
                                            <input type="checkbox" class="check-form-input" id="active" checked={this.state.is_active} onChange={(e) => this.setState({ is_active: e.target.checked })} />
                                            <label for="active"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Enable Sale:</span>
                                            <input type="checkbox" class="check-form-input" id="sale" checked={this.state.enable_sale} onChange={(e) => this.setState({ enable_sale: e.target.checked })} />
                                            <label for="sale"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Locked:</span>
                                            <input type="checkbox" class="check-form-input" id="locked" checked={this.state.is_locked} onChange={(e) => this.setState({ is_locked: e.target.checked })} />
                                            <label for="locked"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Mint:</span>
                                            <input type="checkbox" class="check-form-input" id="mint" checked={this.state.is_minted} onChange={(e) => this.setState({ is_minted: e.target.checked })} />
                                            <label for="mint"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Released:</span>
                                            <input type="checkbox" class="check-form-input" id="released" checked={this.state.is_released} onChange={(e) => this.setState({ is_released: e.target.checked })} />
                                            <label for="released"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Transferring:</span>
                                            <input type="checkbox" class="check-form-input" id="transfer" checked={this.state.is_transferring} onChange={(e) => this.setState({ is_transferring: e.target.checked })} />
                                            <label for="transfer"></label>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-4 col-lg-4">
                                        <div class="form-switch">
                                            <span class="switch-label">Meta:</span>
                                            <input type="checkbox" class="check-form-input" id="meta" checked={this.state.is_meta} onChange={(e) => this.setState({ is_meta: e.target.checked })} />
                                            <label for="meta"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="custom-btn sm-btn semi-dark-btn close-slide" data-dismiss="modal">Close</button>

                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button type="button" class="custom-btn gradiant-btn sm-btn" onClick={(e) => this.onUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : "Update"}</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile
    };
};

const mapDispatchToProps = {
    update,
    addCurrentRoute
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);
